// @core/api/endpoints/project/get_board_view.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  BoardViewResponse,
} from '../../../types/project';

const BASE_PATH = '/project';

/**
 * Get board view
 * Returns the complete board view with items organized by columns, ready for rendering. Optionally filters to a specific sprint.
 */
export async function GetBoardView(
  project_id: string,
  board_id: string,
  options?: RequestOptions
): Promise<BoardViewResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id/boards/:board_id/view`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  requestPath = requestPath.replace(':board_id', encodeURIComponent(board_id));
  const requestOptions = options;
  return client.get<BoardViewResponse>(requestPath, { ...requestOptions });
}
